module.exports = __webpack_public_path__ + "media/error.7f005861.ogg";